<astrea-internal-banner
    *ngIf="!loading"
    title="{{ editorial.editorial }}"
    image="/assets/images/icons/editorials-white.png"
    breadcrumbText="{{ 'pages.editorials.all' | translate }}"
    breadcrumLink="/editorials"
></astrea-internal-banner>

<div class="astrea-editorial content-height p-sm-4 p-2">
    <div class="container" *ngIf="!loading; else astreaLoading">

        <div>

            <div id="books" *ngIf="books && books.length > 0; else withoutResults">
                <div class="products-wrapper">
                    <astrea-book-simple
                        *ngFor="let b of books"
                        [book]="b"
                        class="animated astreaFade"
                    ></astrea-book-simple>
                </div>
            </div>

            <ng-template #withoutResults>
                <div class="t-center mt-3">
                    {{ 'pages.without' | translate }}
                </div>
            </ng-template>

            <div>
                <astrea-paginator
                    [itemsPerPage]="itemsPerPage"
                    [totalLength]="totalLength"
                    [pageRedirect]="'/editorial/' + url"
                ></astrea-paginator>
            </div>

        </div>

    </div>

    <ng-template #astreaLoading>
        <astrea-loading
            [text]="'pages.loading' | translate"
        ></astrea-loading>
    </ng-template>

</div>
